import { useGlobalStore } from '@highlight/ipc/react'

export function useHasSeenHowYouWorkWelcome(): ReturnType<typeof useGlobalStore<boolean>> {
  return useGlobalStore<boolean>('general', 'hasSeenHowYouWorkWelcome', false)
}
